import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { LayoutConfig } from '@spartacus/storefront';

@NgModule({
  declarations: [],
  imports: [
    ConfigModule.withConfig({
      layoutSlots: {
        header: null,
        KnBrProductDetailsPageTemplate: null,
      },
    } as LayoutConfig),

    ConfigModule.withConfig({
      layoutSlots: {
        header: {
          lg: {
            slots: ['SiteLogo', 'SiteContext'],
          },
          slots: ['SiteLogo', 'SiteContext'],
        },
        ErrorPageTemplate: {
          slots: ['TopContent', 'MiddleContent', 'BottomContent'],
        },
        KnBrLoginPageTemplate: {
          slots: ['SiteLogo', 'SiteTitle', 'LeftContentSlot'],
        },
        LandingPage2Template: {
          slots: ['Section1', 'Section2'],
        },
        KnBrProductListPageTemplate: {
          slots: ['BottomHeaderSlot', 'SearchBox', 'Section1', 'ProductLeftRefinements', 'ProductListSlot'],
        },
        KnBrProductGridPageTemplate: {
          slots: ['BottomHeaderSlot', 'SearchBox', 'Section1', 'ProductLeftRefinements', 'ProductGridSlot'],
        },
        KnBrSearchResultsListPageTemplate: {
          slots: ['SearchBox', 'Section1', 'ProductLeftRefinements', 'SearchResultsListSlot'],
        },
        KnBrSearchResultsGridPageTemplate: {
          slots: ['SearchBox', 'Section1', 'ProductLeftRefinements', 'SearchResultsGridSlot'],
        },
        KnBrDraftOrderPageTemplate: {
          slots: ['TopContent', 'KnBrDraftOrderListActionBarSlot', 'BodyContent'],
        },
        KnBrDraftOrderCreatePageTemplate: {
          slots: ['BodyContent'],
        },
        KnBrDraftOrderDetailPageTemplate: {
          slots: [
            'KnBrDraftOrderHeaderSlot',
            'KnBrDraftOrderActionBarSlot',
            'KnBrDraftOrderItemsSlot',
            'KnBrEmptyCartSlot',
          ],
        },
        KnBrQuoteCreatePageTemplate: {
          slots: ['BodyContent'],
        },
        KnBrQuoteDetailPageTemplate: {
          slots: ['KnBrQuoteHeaderSlot', 'KnBrQuoteItemsSlot', 'KnBrEmptyCartSlot'],
        },
        KnBrOrderConfirmationPageTemplate: {
          slots: ['BodyContent', 'SideContent'],
        },
        KnBrQuotePageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrProductDetailsPageTemplate: {
          lg: {
            pageFold: 'UpSelling',
          },
          pageFold: 'Summary',
          slots: [
            'BottomHeaderSlot',
            'Summary',
            'UpSelling',
            'CrossSelling',
            'ProductFeatures',
            'Tabs',
            'PlaceholderContentSlot',
          ],
        },
        knBrQuoteSellerApproverTemplate: {
          slots: ['SiteLogo', 'SiteTitle', 'LeftContentSlot'],
        },
        KnBrCustomer360PageTemplate: {
          slots: ['TopContent', 'MiddleContent', 'BottomContent', 'BodyContent'],
        },
        KnBrOrderHistoryPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrOrderDetailsPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrReturnHistoryPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrReturnDetailsPageTemplate: {
          slots: ['BodyContent'],
        },
        CarlisleInvoiceDetailsPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        CarlisleAccountDetailsPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        CarlisleShippingListingPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrInvoiceListPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrAddressBookPageTemplate: {
          slots: ['BodyContent'],
        },
        KnBrFactSheetPageTemplate: {
          slots: ['TopContent', 'MiddleContent'],
        },
        KnBrOrderImportPageTemplate: {
          slots: ['BodyContent'],
        },
        KnBrQuickOrderPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrOrderFormsPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrQuickEntryPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
         KnBrPurchasingAgentPageTemplate: {
          slots: ['Section2'],
        },
        NACPageTemplate: {
          slots: ['TopContent', 'BottomContent'],
        },
        KnBrMarketCentrePageTemplate: {
          slots: ['LeftContentSlot', 'RightContentSlot', 'MiddleLeftContentSlot'],
        },
        ContentPage1Template: {
          slots: ['Section2A','Section1'],
        },
        CarlisleCaseCreationPageTemplate: {
          slots: ['BodyContent']
        },
        CarlisleCaseListPageTemplate: {
          slots: ['BodyContent']
        },
        CarlisleCaseDetailPageTemplate: {
          slots: ['BodyContentCaseDetail']
        },
        SalesLandingPage2Template: {
          slots: ['BottomHeaderSlot','Section1', 'Section3', 'Section4', 'Section5', 'Section6']
        },
        CarlisleFindMyContactPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        CarlisleShipmentArrivalsPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        CarlisleOrderConfirmationLedgerPageTemplate: {
          slots: ['BodyContent'],
        }
      },
    } as LayoutConfig),
  ],
})
export class KnBrLayoutConfigModule {}
